import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AlertTriangle } from 'lucide-react';

import { describeSavedExpensePolicy, formatPolicyAmount } from '../config/expensePolicyHelpers';

// Uyarı yalnız detayda kalmasın: talebi listeleyen herkes (çalışan, onaylayan,
// ödemeyi yapan) tutarın yanında limit aşımını ve ödenecek tutarı görür.
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-family: 'Nunito Sans', sans-serif;
`;

const Amount = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #b71c1c;
  white-space: nowrap;
`;

const Payable = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #b71c1c;
  white-space: nowrap;
`;

export default function ExpenseAmountCell({ row }) {
  const { t } = useTranslation();

  if (!row) return <span>-</span>;

  const currency = row.currency || 'TRY';
  const policy = describeSavedExpensePolicy(row);

  return (
    <Wrap>
      <Amount>{formatPolicyAmount(row.totalAmount, currency)}</Amount>
      {policy && (
        <Badge data-testid="expense-limit-badge">
          <AlertTriangle size={12} />
          {t('expense.policy.badge')}
        </Badge>
      )}
      {policy?.showsPayable && (
        <Payable>{t('expense.policy.payableShort', { amount: formatPolicyAmount(policy.payableAmount, currency) })}</Payable>
      )}
    </Wrap>
  );
}
